"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var AbstractEntityFilter_1 = require("../../../core/model/overview/AbstractEntityFilter");

var SelloutReleaseType_1 = require("../../../release/model/sellout/SelloutReleaseType");
/**
 * Contains input (filter) data to generate report of terminated sellout prices.
 * TODO JPK: This may (and probably will) change, when implementing AG grid server side filtering.
 *
 * @author Jan Prokop
 */


var SelloutTerminationReportFilterDTO =
/*#__PURE__*/
function (_AbstractEntityFilter) {
  _inherits(SelloutTerminationReportFilterDTO, _AbstractEntityFilter);

  function SelloutTerminationReportFilterDTO(categoryIds, selloutTypes, priceZoneId, siteIds, productExternalIds, endDateFrom, endDateTo) {
    var _this;

    _classCallCheck(this, SelloutTerminationReportFilterDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutTerminationReportFilterDTO).call(this));
    _this.categoryIds = categoryIds;
    _this.selloutTypes = selloutTypes;
    _this.priceZoneId = priceZoneId;
    _this.siteIds = siteIds;
    _this.productExternalIds = productExternalIds;
    _this.endDateFrom = endDateFrom;
    _this.endDateTo = endDateTo;
    return _this;
  }

  _createClass(SelloutTerminationReportFilterDTO, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new SelloutTerminationReportFilterDTO(mat.categoryIds, mat.selloutTypes, mat.priceZoneId, mat.siteIds, mat.productExternalIds, mat.endDateFrom, mat.endDateTo);
    }
  }]);

  return SelloutTerminationReportFilterDTO;
}(AbstractEntityFilter_1.AbstractEntityFilter);

exports.SelloutTerminationReportFilterDTO = SelloutTerminationReportFilterDTO;

SelloutTerminationReportFilterDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutTerminationReportFilterDTO.name);
  return {
    categoryIds: builder.opt(builder.listOf(builder.lookup('categoryIds', "".concat(CodebookLookupSequence_1.CodebookLookupSequence.Category)))),
    selloutTypes: builder.opt(builder.listOf(builder.senum('selloutTypes', SelloutReleaseType_1.SelloutReleaseType, CodebookLookupSequence_1.CodebookLookupSequence.SelloutReleaseType))),
    priceZoneId: builder.lookup('priceZoneId', "".concat(CodebookLookupSequence_1.CodebookLookupSequence.PriceZone)),
    siteIds: builder.opt(builder.listOf(builder.lookup('siteIds', "".concat(CodebookLookupSequence_1.CodebookLookupSequence.InternalSites)))),
    productExternalIds: builder.opt(builder.listOf(builder.str('productExternalIds'))),
    endDateFrom: builder.date('endDateFrom', DateParser_1.DateParser.ISO_PATTERN),
    endDateTo: builder.date('endDateTo', DateParser_1.DateParser.ISO_PATTERN),
    limit: builder.opt(builder.num('limit')),
    offset: builder.opt(builder.num('offset'))
  };
}();